<div class="toolbarheader">WILL: Enriching Life Through Learning in Community
    <span class="spacer"></span>
    <button *ngIf="lightningService.role.update_pages" class="button-style" routerLink="/admin-page-update/index"><mat-icon>edit</mat-icon></button>
</div>
<img src="{{ header_image }}" alt="banner" width="100%">


<div [innerHtml]="html_safe_text | safe: 'html'"></div>